import React from 'react';
import BusinessContainers from 'pages/AdvisoryDashboard/components/BusniessContainers/BusinessContainers';
import Overview from './Overview';
import BusinessCase from './BusinessCase/BusinessCase';

const WidgetsObject = () => {
    const Widgets = (props) => ({
        Overview: <Overview {...props} />,
        BusinessCase: <BusinessCase {...props} />,
        Containers: <BusinessContainers {...props} />,
    });

    return Widgets;
};

export default WidgetsObject;
